import React from 'react'
import Button from '@mui/material/Button'
import EmailIcon from '@mui/icons-material/Email'
import SendIcon from '@mui/icons-material/Send'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useDispatch } from 'react-redux'
import { useFirebase } from 'react-redux-firebase'
import { InputAdornment } from '@mui/material'
import { actions as appActions } from '../../App/reducer'
import { REGEX_EMAIL } from '../../../config'

interface Props {
  onClose: () => void
}

export const ResetModalComponent: React.FC<Props> = ({ onClose }) => {
  const [email, setEmail] = React.useState('')
  const [emailNotValid, setEmailNotValid] = React.useState(false)

  React.useEffect(
    () => () => {
      setEmail('')
      setEmailNotValid(false)
    },
    [setEmail, setEmailNotValid]
  )

  const dispatch = useDispatch()
  const firebase = useFirebase()

  const onSubmit = React.useCallback(() => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch(
          appActions.onAlert({
            severity: 'success',
            message: 'Check your Email',
          })
        )
        onClose()
      })
      .catch((error) => {
        console.log('Error!', error.message)
        dispatch(
          appActions.onAlert({
            severity: 'error',
            message: 'Failed to reset password',
          })
        )
      })
  }, [email, dispatch, onClose])

  const onChange = React.useCallback(
    (e: { target: { value: React.SetStateAction<string> } }) => {
      setEmail(e.target.value)
    },
    [setEmail]
  )

  return (
    <Dialog fullWidth maxWidth="sm" open onClose={onClose}>
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          onChange={onChange}
          label="Email Address"
          type="email"
          value={email}
          fullWidth
          error={emailNotValid}
          helperText={emailNotValid ? 'Email not valid' : ''}
          onBlur={() => email && setEmailNotValid(!REGEX_EMAIL.test(email))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions
        sx={{
          ml: 2,
          mr: 2,
          justifyContent: 'space-between',
        }}
      >
        <Button onClick={onClose}>Cancel</Button>
        <Button
          disabled={emailNotValid}
          variant="contained"
          startIcon={<SendIcon />}
          onClick={onSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}
